import request from '@/utils/request'
const url = process.env.VUE_APP_PASS_API
const path = process.env.VUE_APP_BSN_API
function getAppVersion() {
    const userAgent = window.navigator.userAgent
    const matchArr = userAgent.match(/Banma-(\S*) BM/) || userAgent.match(/Banma-(\S*)\(/)
    let ret = '99.99' // 默认版本号
    if (matchArr && matchArr.length > 0) {
        ret = matchArr[1]
    }
    return ret
}
const appVersion = getAppVersion()
export function getHome(params) {
    return request({
        url: '/bmmatch/GetHome',
        method: 'get',
        params: params
    })
}

export function getBMMatchInfo(params) {
    return request({
        url: '/bmmatch/GetBMMatchInfo',
        method: 'get',
        params: params
    })
}
export function getGameScore(params) {
    return request({
        url: process.env.VUE_APP_BEIBING_API + '/api/content/pc/' + 'GetGameScore.json',
        method: 'get',
        params: params
    })
}

export function adminResetScoreboardGame(params) {
    return request({
        url: '/bmmatch/AdminResetScoreboardGame',
        method: 'get',
        params: params
    })
}
export function getUserCrmInviteList(params) {
    return request({
        url: '/bmmatch/GetUserCrmInviteList',
        method: 'get',
        params: params
    })
}
export function getBMMatchTeamOffice(params) {
    return request({
        url: '/bmmatch/GetBMMatchTeamOffice',
        method: 'get',
        params: params
    })
}

export function getBMMatchGameList(params) {
    return request({
        url: '/bmmatch/GetBMMatchGameList',
        method: 'get',
        params: params
    })
}

export function getBMTeamScores(params) {
    return request({
        url: '/bmmatch/GetBMTeamScores',
        method: 'get',
        params: params
    })
}

export function getBMMatchRankList(params) {
    return request({
        url: '/bmmatch/GetBMMatchRankList',
        method: 'get',
        params: params
    })
}

export function getBMMatchTeamList(params) {
    return request({
        url: '/bmmatch/GetBMMatchTeamList',
        method: 'get',
        params: params
    })
}

/** 获取我管理的球队列表 */
export function getOrgTeamsManaged(params) {
    return request({
        url: '/bmmatch/registration/org-teams/managed',
        method: 'get',
        params: params
    })
}

/** 获取机构球队详情 */
export function getOrgTeamDetail(orgTeamId) {
    return request({
        url: `/bmmatch/registration/org-teams/${orgTeamId}`,
        method: 'get'
    })
}

/** 获取机构球队下的注册球员列表（选择添加用） */
export function getOrgTeamPlayers(orgTeamId) {
    return request({
        url: `/bmmatch/registration/reg-teams/${orgTeamId}/reg-players`,
        method: 'get',
        params: {
            role: 'teamManager',
            statusFilter: 10
        }
    })
}

/** 获取注册球队的工作人员列表（选择添加用） GET reg-teams/{regTeamId}/reg-team-officers */
export function getOrgTeamOfficers(regTeamId, params = {}) {
    return request({
        url: `/bmmatch/registration/reg-teams/${regTeamId}/reg-team-officers`,
        method: 'get',
        params: {
            role: 'teamManager',
            statusFilter: '1,10',
            pageNum: 1,
            pageSize: 20,
            ...params
        }
    })
}

/** 选择已有球队报名赛事组别 */
export function signupBMMatchByTeam(data) {
    return request({
        url: '/bmmatch/SignupBMMatchByTeam',
        method: 'post',
        data
    })
}

/** 检查球队是否满足当前赛事组别报名条件 */
export function checkTeamSignupBMMatch(params) {
    return request({
        url: '/bmmatch/CheckTeamSignupBMMatch',
        method: 'get',
        params
    })
}

export function GetBMGameLiveDetail(params) {
    return request({
        url: url + '/api/GetBMGameLiveDetail.json',
        method: 'get',
        params: params
    })
}
export function GetBMGameInteractiveStats(params) {
    return request({
        url: url + '/api/GetBMGameInteractiveStats.json',
        method: 'get',
        params: params
    })
}
export function OnVideoDownload(params) {
    return request({
        url: url + '/api/OnVideoDownload.json',
        method: 'get',
        params: params
    })
}
export function OnVideoShare(params) {
    return request({
        url: url + '/api/OnVideoShare.json',
        method: 'get',
        params: params
    })
}
export function closeBMFieldGameLiveRoom(params) {
    return request({
        url: url + '/api/CloseBMFieldGameLiveRoom.json',
        method: 'get',
        params: params
    })
}
export function reverseBMGameLiveScoreboard(params) {
    return request({
        url: url + '/api/ReverseBMGameLiveScoreboard.json',
        method: 'get',
        params: params
    })
}
export function getBMFieldExistOtherGameLivePrepare(params) {
    return request({
        url: url + '/api/GetBMFieldExistOtherGameLivePrepare.json',
        method: 'get',
        params: params
    })
}
export function addBMGameLiveTag(params) {
    return request({
        url: url + '/api/AddBMGameLiveTag.json',
        method: 'get',
        params: params
    })
}

export function updateBMGameServingSide(params) {
    return request({
        url: url + '/api/UpdateBMGameServingSide.json',
        method: 'get',
        params: params
    })
}
export function updateBMGameStages(params) {
    return request({
        url: url + '/api/UpdateBMGameStagesScore.json',
        method: 'get',
        params: params
    })
}
export function updateBMGameStages2(params) {
    return request({
        url: url + '/api/UpdateBMGameStages.json',
        method: 'get',
        params: params
    })
}
export function getBMGameStageList(params) {
    return request({
        url: url + '/api/GetBMGameStageList.json',
        method: 'get',
        params: params
    })
}
export function addBMGameLiveScore(params) {
    return request({
        url: url + '/api/AddBMGameLiveScore.json',
        method: 'get',
        params: params
    })
}
export function updateBMGameStageScore2(params) {
    return request({
        url: url + '/api/UpdateBMGameStageScore2.json',
        method: 'get',
        params: params
    })
}
export function getBMGameLiveStatus(params) {
    return request({
        url: url + '/api/GetBMGameLiveStatus.json',
        method: 'get',
        params: params
    })
}
export function startBMFieldGameWarmup(params) {
    return request({
        url: url + '/api/StartBMFieldGameWarmup.json',
        method: 'get',
        params: params
    })
}

export function BKLikeGameTeam(params) {
    return request({
        url: url + '/api/BKLikeGameTeam.json',
        method: 'get',
        params: params
    })
}

export function GetBMGameBktData(params) {
    return request({
        url: url + '/api/GetBMGameBktData.json',
        method: 'get',
        params: params
    })
}

export function GetBMGameDetail(params) {
    return request({
        url: url + '/api/GetBMGameDetail.json',
        method: 'get',
        params: params
    })
}

/** BK 场次详情（含 game.interactEnabled / game.commentEnabled，与 game1 一致） */
export function bkGetGameDetail(params) {
    return request({
        url: url + '/api/BKGetGameDetail.json',
        method: 'get',
        params
    })
}

export function GetCommentList(params) {
    return request({
        url: url + '/api/GetCommentList.json',
        method: 'get',
        params: params
    })
}

export function AddComment(params) {
    return request({
        url: url + '/api/AddComment.json',
        method: 'get',
        params: params
    })
}

export function playerCardReseller(data) {
    return request({
        url: url + '/api/UpdatePlayerCardReseller.json',
        method: 'post',
        data: data
    })
}

export function getPlayerCardReseller(params) {
    return request({
        url: url + '/api/GetPlayerCardReseller.json',
        method: 'get',
        params: params
    })
}

export function getPlayerCardOrderList(params) {
    return request({
        url: url + '/api/AdminGetPlayerCardOrderList.json',
        method: 'get',
        params: params
    })
}

export function getPlayerCardOrderDetail(params) {
    return request({
        url: url + '/api/AdminGetPlayerCardOrderDetail.json',
        method: 'get',
        params: params
    })
}
export function createPlayerCardOrderRefundApply(params) {
    return request({
        url: url + '/api/AdminCreatePlayerCardOrderRefundApply.json',
        method: 'get',
        params: params
    })
}

export function adminGetMatchList(params) {
    return request({
        url: '/bmmatch/AdminGetMatchList',
        method: 'get',
        params: params
    })
}
export function adminGetBMUnionMatchStages(params) {
    return request({
        url: '/bmmatch/AdminGetBMUnionMatchStages',
        method: 'get',
        params: params
    })
}
export function adminAddBMGameTeamSubstitutionCount(params) {
    return request({
        url: '/bmmatch/AdminAddBMGameTeamSubstitutionCount',
        method: 'get',
        params: params
    })
}
export function adminAddBMGameTeamFoulCount(params) {
    return request({
        url: '/bmmatch/AdminAddBMGameTeamFoulCount',
        method: 'get',
        params: params
    })
}

export function adminGetBMUnionMatch(params) {
    return request({
        url: '/bmmatch/AdminGetBMUnionMatch',
        method: 'get',
        params
    })
}

export function adminGetBMBktGameData(params) {
    return request({
        url: '/bmmatch/AdminGetBMBktGameData',
        method: 'get',
        params
    })
}

export function adminDeleteBMMatchGame(data) {
    return request({
        url: '/bmmatch/AdminDeleteBMMatchGame',
        method: 'post',
        data: data
    })
}

export function adminGetBMMatchTeamList2(params) {
    return request({
        url: '/bmmatch/AdminGetBMMatchTeamList2',
        method: 'get',
        params
    })
}

export function OnPlayGameVideo(params) {
    return request({
        url: path + '/bmyouth/OnPlayGameVideo',
        method: 'get',
        params: params
    })
}
export function GetMatchLivePriceSetting(params) {
    return request({
        url: path + '/bmyouth/GetMatchLivePriceSetting',
        method: 'get',
        params: params
    })
}

export function BYCreateOrder(params) {
    return request({
        url: url + '/api/BYCreateOrder.json',
        method: 'get',
        params: params
    })
}

// export function BKGetGameDetail(params) {
//     return request({
//         url: url + '/api/GetBMGameLiveDetail.json',
//         method: 'get',
//         params: params
//     })
// }
// // GetBMGameLiveDetail
// export function BKGetGameLiveInfo(params) {
//     return request({
//         url: url + '/api/GetBMGameLiveDetail.json',
//         method: 'get',
//         params: params
//

export function getBMMatchList2(params) {
    return request({
        url: '/bmmatch/GetBMMatchList2',
        method: 'get',
        params
    })
}

export function getBMUnionMatch(params) {
    return request({
        url: '/bmmatch/GetBMUnionMatch',
        method: 'get',
        params
    })
}

export function getBMMatchList(params) {
    return request({
        url: '/bmmatch/GetBMMatchList',
        method: 'get',
        params
    })
}

export function adminGetBMMatch(params) {
    return request({
        url: '/bmmatch/AdminGetBMMatch',
        method: 'get',
        params
    })
}

export function adminGetBMBktGameEventPlayerList(params) {
    return request({
        url: '/bmmatch/AdminGetBMBktGameEventPlayerList',
        method: 'get',
        params
    })
}
export function adminCancelLatestGoalTag(params) {
    return request({
        url: '/bmmatch/AdminCancelLatestGoalTag',
        method: 'get',
        params
    })
}
export function adminDeleteScoreboard(params) {
    return request({
        url: '/bmmatch/AdminDeleteScoreboard',
        method: 'get',
        params
    })
}
export function adminGetIsScoreboardExistOngoingGame(params) {
    return request({
        url: '/bmmatch/AdminGetIsScoreboardExistOngoingGame',
        method: 'get',
        params
    })
}
export function adminGetScoreboardOngoingGame(params) {
    return request({
        url: '/bmmatch/AdminGetScoreboardOngoingGame',
        method: 'get',
        params
    })
}
export function adminReverseBMGameScoreboard(params) {
    return request({
        url: '/bmmatch/AdminReverseBMGameScoreboard',
        method: 'get',
        params
    })
}

export function adminGetBMMatchTeam(params) {
    return request({
        url: '/bmmatch/AdminGetBMMatchTeam',
        method: 'get',
        params
    })
}

export function adminGetBMMatchTeamPlayer(params) {
    return request({
        url: '/bmmatch/AdminGetBMMatchTeamPlayer',
        method: 'get',
        params
    })
}

export function getBMMatchTeamPlayer(params) {
    return request({
        url: '/bmmatch/GetBMMatchTeamPlayer',
        method: 'get',
        params
    })
}

export function createBMMatchTeam(data) {
    return request({
        url: '/bmmatch/CreateBMMatchTeam',
        method: 'post',
        data: data
    })
}

export function adminUpdateBMMatchGroupTeam(data) {
    return request({
        url: '/bmmatch/AdminUpdateBMMatchGroupTeam',
        method: 'post',
        data: data
    })
}

export function adminUpdateBMMatchTeamPlayer(data) {
    return request({
        url: '/bmmatch/AdminUpdateBMMatchTeamPlayer',
        method: 'post',
        data: data
    })
}

export function adminCreateBMMatchGroupTeam(data) {
    return request({
        url: '/bmmatch/AdminCreateBMMatchGroupTeam',
        method: 'post',
        data: data
    })
}

export function adminCreateBMMatchTeamPlayer(data) {
    return request({
        url: '/bmmatch/AdminCreateBMMatchTeamPlayer',
        method: 'post',
        data: data
    })
}

export function adminCreateBMTeam(data) {
    return request({
        url: '/bmmatch/AdminCreateBMTeam',
        method: 'post',
        data: data
    })
}

export function adminUpdateBMMatchTeam(data) {
    return request({
        url: '/bmmatch/AdminUpdateBMMatchTeam',
        method: 'post',
        data: data
    })
}

export function adminUpdateBMBktGameEvent(data) {
    return request({
        url: '/bmmatch/AdminUpdateBMBktGameEvent',
        method: 'post',
        data: data
    })
}

export function getMatchTeamListByUser(params) {
    return request({
        url: '/bmmatch/GetMatchTeamListByUser',
        method: 'get',
        params
    })
}

export function adminGetBMMatchSignupTeamList(params) {
    return request({
        url: '/bmmatch/AdminGetBMMatchSignupTeamList',
        method: 'get',
        params
    })
}

export function createBMMatchTeamOffice(data) {
    return request({
        url: '/bmmatch/CreateBMMatchTeamOffice',
        method: 'post',
        data: data
    })
}

export function updateBMMatchTeamOffice(data) {
    return request({
        url: '/bmmatch/UpdateBMMatchTeamOffice',
        method: 'post',
        data: data
    })
}

export function deleteBMMatchTeamOffice(data) {
    return request({
        url: '/bmmatch/DeleteBMMatchTeamOffice',
        method: 'post',
        data: data
    })
}

export function updateBMMatchTeam(data) {
    return request({
        url: '/bmmatch/UpdateBMMatchTeam',
        method: 'post',
        data: data
    })
}

export function getBMMatchTeamSignup(params) {
    return request({
        url: '/bmmatch/GetBMMatchTeamSignup',
        method: 'get',
        params
    })
}

/** 检查球员报名（选择添加前：同时间段其他赛事、已加入其他球队等） */
export function checkBMMatchTeamPlayerSignup(params) {
    return request({
        url: '/bmmatch/CheckBMMatchTeamPlayerSignup',
        method: 'get',
        params
    })
}

/** 选择已有队员报名（publicSignUp=2 使用 regPlayerId，字段为 playerIds，逗号分隔） */
export function createBMMatchTeamPlayersByPlayers(data) {
    return request({
        url: '/bmmatch/CreateBMMatchTeamPlayersByPlayers',
        method: 'post',
        data: data
    })
}

/** 批量添加工作人员（Query: matchId, teamId；Body: officers 数组，仅职务在 match.teamOfficers 内的才传） */
export function batchCreateBMMatchTeamOffice(params, data) {
    return request({
        url: '/bmmatch/BatchCreateBMMatchTeamOffice',
        method: 'post',
        params,
        data
    })
}

export function createBMMatchTeamPlayer(data) {
    return request({
        url: '/bmmatch/CreateBMMatchTeamPlayer',
        method: 'post',
        data: data
    })
}

export function updateBMMatchTeamPlayer(data) {
    return request({
        url: '/bmmatch/UpdateBMMatchTeamPlayer',
        method: 'post',
        data: data
    })
}

/** 编辑球员信息时：检查球衣号码是否可用 */
export function checkJerseyNumberAvailability(params) {
    return request({
        url: '/bmmatch/CheckJerseyNumberAvailability',
        method: 'get',
        params
    })
}

/** 交换两个球员的球衣号码 */
export function swapJerseyNumbers(data) {
    return request({
        url: '/bmmatch/SwapJerseyNumbers',
        method: 'post',
        data
    })
}

export function deleteBMMatchTeamPlayer(data) {
    return request({
        url: '/bmmatch/DeleteBMMatchTeamPlayer',
        method: 'post',
        data: data
    })
}

export function createBMMatchSingle(data) {
    return request({
        url: '/bmmatch/CreateBMMatchSingle',
        method: 'post',
        data: data
    })
}

export function updateBMMatchSingle(data) {
    return request({
        url: '/bmmatch/UpdateBMMatchSingle',
        method: 'post',
        data: data
    })
}

export function createBMMatchGroupTeam(data) {
    return request({
        url: '/bmmatch/CreateBMMatchGroupTeam',
        method: 'post',
        data: data
    })
}

export function updateBMMatchGroupTeam(data) {
    return request({
        url: '/bmmatch/UpdateBMMatchGroupTeam',
        method: 'post',
        data: data
    })
}

export function getCrmAccountHome(params) {
    return request({
        url: '/bmmatch/GetCrmAccountHome',
        method: 'get',
        params
    })
}
export function adminCancelLatestPauseTag(params) {
    return request({
        url: '/bmmatch/AdminCancelLatestPauseTag',
        method: 'get',
        params
    })
}
export function adminAddBMGameClock(params) {
    return request({
        url: '/bmmatch/AdminAddBMGameClock',
        method: 'get',
        params
    })
}

export function getCrmAccountUnionMatchList(params) {
    return request({
        url: '/bmmatch/GetCrmAccountUnionMatchList',
        method: 'get',
        params
    })
}
export function adminUpdateBMGameServingSide(params) {
    return request({
        url: '/bmmatch/AdminUpdateBMGameServingSide',
        method: 'get',
        params
    })
}


export function getCrmNewsList(params) {
    return request({
        url: '/bmmatch/GetCrmNewsList',
        method: 'get',
        params
    })
}

export function getCrmNews(params) {
    return request({
        url: '/bmmatch/GetCrmNews',
        method: 'get',
        params
    })
}

export function getCrmAccountUnionMatchSignupList(params) {
    return request({
        url: '/bmmatch/GetCrmAccountUnionMatchSignupList',
        method: 'get',
        params
    })
}
export function adminUpdateBMGameStageIsGolden(params) {
    return request({
        url: '/bmmatch/AdminUpdateBMGameStageIsGolden',
        method: 'get',
        params
    })
}

export function getCrmAccountIntro(params) {
    return request({
        url: '/bmmatch/GetCrmAccountIntro',
        method: 'get',
        params
    })
}

export function getMyCrmUnionMatchList(params) {
    return request({
        url: '/bmmatch/GetMyCrmUnionMatchList',
        method: 'get',
        params
    })
}

export function cancelBMMatchTeam(data) {
    return request({
        url: '/bmmatch/CancelBMMatchTeam',
        method: 'post',
        data: data
    })
}

export function getBMMatchTeamClaimDetail(params) {
    return request({
        url: '/bmmatch/GetBMMatchTeamClaimDetail',
        method: 'get',
        params
    })
}

export function claimTeam(data) {
    return request({
        url: '/bmmatch/ClaimTeam',
        method: 'post',
        data: data
    })
}

export function getAreaTreeList(params) {
    return request({
        url: '/bmmatch/GetAreaTreeList',
        method: 'get',
        params
    })
}

export function getPlayerDigitalQualificationCard(params) {
    return request({
        url: '/bmmatch/GetPlayerDigitalQualificationCard',
        method: 'get',
        params
    })
}

export function getCrmMerchantUnionMatchList(params) {
    return request({
        url: '/bmmatch/GetCrmMerchantUnionMatchList',
        method: 'get',
        params
    })
}

export function getMerchantMatchTeamListByUser(params) {
    return request({
        url: '/bmmatch/GetMerchantMatchTeamListByUser',
        method: 'get',
        params
    })
}

export function getMerchantMatchUnionListByUser(params) {
    return request({
        url: '/bmmatch/GetMerchantMatchUnionListByUser',
        method: 'get',
        params
    })
}

export function getUnionMatchManagerInviteList(params) {
    return request({
        url: '/bmmatch/GetUnionMatchManagerInviteList',
        method: 'get',
        params
    })
}

export function acceptUnionMatchManagerInvite(params) {
    return request({
        url: '/bmmatch/AcceptUnionMatchManagerInvite',
        method: 'get',
        params
    })
}
export function acceptCrmInvite(params) {
    return request({
        url: '/bmmatch/AcceptCrmInvite',
        method: 'get',
        params
    })
}
export function adminUpdateScoreboard(params) {
    return request({
        url: '/bmmatch/AdminUpdateUnionMatchScoreboardSettings',
        method: 'get',
        params
    })
}
export function adminGetUnionMatchScoreboardSettings(params) {
    return request({
        url: '/bmmatch/AdminGetUnionMatchScoreboardSettings',
        method: 'get',
        params
    })
}

export function adminGetBMUnionMatchGameList(params) {
    return request({
        url: '/bmmatch/AdminGetBMUnionMatchGameList',
        method: 'get',
        params
    })
}

export function adminGetBMMatchStageGameList(params) {
    return request({
        url: '/bmmatch/AdminGetBMMatchStageGameList',
        method: 'get',
        params
    })
}

export function adminGetBMMatchGameList(params) {
    return request({
        url: '/bmmatch/AdminGetBMMatchGameList',
        method: 'get',
        params
    })
}
export function getPenaltyShootoutData(params) {
    return request({
        url: '/bmmatch/GetPenaltyShootoutData',
        method: 'get',
        params
    })
}

export function adminUpdateBMMatchRoundGames(data) {
    return request({
        url: '/bmmatch/AdminUpdateBMMatchRoundGames',
        method: 'post',
        data
    })
}
export function adminUpdatePenaltyShootoutData(data) {
    return request({
        url: '/bmmatch/AdminUpdatePenaltyShootoutData',
        method: 'post',
        data
    })
}

export function adminUpdateBMMatchGame(data) {
    return request({
        url: '/bmmatch/AdminUpdateBMMatchGame',
        method: 'post',
        data
    })
}
export function adminCreateBMMatchGame(data) {
    return request({
        url: '/bmmatch/AdminCreateBMMatchGame',
        method: 'post',
        data
    })
}

export function adminGetBMMatchGame(params) {
    return request({
        url: '/bmmatch/AdminGetBMMatchGame',
        method: 'get',
        params
    })
}

export function adminGetBMUnionMatchList(params) {
    return request({
        url: '/bmmatch/AdminGetBMUnionMatchList',
        method: 'get',
        params
    })
}

// export function getBMStageGamesByBMMatchId(params) {
//     return request({
//         url: url + '/api/GetBMGamesByBMMatchId.json',
//         method: 'get',
//         params
//     })
// }

export function getBMMatchDetail(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMMatchDetail.json',
        method: 'get',
        params
    })
}

export function getBMMatchSponsorList(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMMatchSponsorList.json',
        method: 'get',
        params
    })
}


export function bkGetBMGameBktData(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMGameBktData.json',
        method: 'get',
        params
    })
}

export function getBMGameDetail(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMGameDetail.json',
        method: 'get',
        params
    })
}

export function getBMGamesByBMMatchId(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMGamesByBMMatchId.json',
        method: 'get',
        params
    })
}
//GetBMGamesByBMMatchId3
export function getBMGamesByBMMatchId3(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMGamesByBMMatchId3.json',
        method: 'get',
        params
    })
}

export function getBMShooterScores(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMShooterScores.json',
        method: 'get',
        params
    })
}

export function getBMAssisterScores(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMAssisterScores.json',
        method: 'get',
        params
    })
}

export function getRedOrYellowCardByBMMatchId(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetRedOrYellowCardByBMMatchId.json',
        method: 'get',
        params
    })
}

export function getBMRebounds(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMRebounds.json',
        method: 'get',
        params
    })
}

export function getBMPlayerList(params) {
    return request({
        url: url + '/api/content/phone/GetBMPlayerList.json',
        method: 'get',
        params
    })
}

export function getBMSteals(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMSteals.json',
        method: 'get',
        params
    })
}

export function getBMBlocks(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMBlocks.json',
        method: 'get',
        params
    })
}

export function getBMTeamScores1(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMTeamScores.json',
        method: 'get',
        params
    })
}

export function getBMRugbyMatchPlayerStats(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMRugbyMatchPlayerStats.json',
        method: 'get',
        params
    })
}

export function getBMMatchInfo1(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMMatchInfo.json',
        method: 'get',
        params
    })
}

export function getPlayerCardTemplateList(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetPlayerCardTemplateList.json',
        method: 'get',
        params
    })
}

export function getBMRugbyMatchTeamStats(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMRugbyMatchTeamStats.json',
        method: 'get',
        params
    })
}

export function getBMRugbyGameStats(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMRugbyGameStats.json',
        method: 'get',
        params
    })
}

export function getBMGameBktData(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/GetBMGameBktData.json',
        method: 'get',
        params
    })
}

export function getBMFootballGameStats(params) {
    params.appVersion = appVersion
    return request({
        url: url + '/api/content/phone/XGetBMFootballGameStats.json',
        method: 'get',
        params
    })
}

export function getBMStageGamesByBMMatchId(params) {
    return request({
        url: url + '/api/GetBMStageGamesByBMMatchId.json',
        method: 'get',
        params: params
    })
}

export function getBMMatchStageGameList(params) {
    return request({
        url: '/bmmatch/GetBMMatchStageGameList',
        method: 'get',
        params: params
    })
}

export function adminGetBMUnionMatchManager(params) {
    return request({
        url: '/bmmatch/AdminGetBMUnionMatchManager',
        method: 'get',
        params
    })
}

export function adminCreateBMUnionMatchManager(data) {
    return request({
        url: '/bmmatch/AdminCreateBMUnionMatchManager',
        method: 'post',
        data
    })
}

export function adminUpdateBMUnionMatchManager(data) {
    return request({
        url: '/bmmatch/AdminUpdateBMUnionMatchManager',
        method: 'post',
        data
    })
}

export function adminDeleteBMUnionMatchManager(data) {
    return request({
        url: '/bmmatch/AdminDeleteBMUnionMatchManager',
        method: 'post',
        data
    })
}

export function getUserRoles(params) {
    return request({
        url: '/bmmatch/GetUserRoles',
        method: 'get',
        params
    })
}

export function bMMatchOrganizationUpdateBMGameEvents(data) {
    return request({
        url: url + '/api/BMMatchOrganizationUpdateBMGameEvents.json',
        method: 'post',
        data
    })
}

export function adminAddBMGameEvent(data) {
    return request({
        url: '/bmmatch/AdminAddBMGameEvent',
        method: 'post',
        data
    })
}

export function adminUpdateBMGameEvent(data) {
    return request({
        url: '/bmmatch/AdminUpdateBMGameEvent',
        method: 'post',
        data
    })
}

export function getBMGameEventList(params) {
    return request({
        url: '/bmmatch/GetBMGameEventList',
        method: 'get',
        params
    })
}

export function getBMMatchTennisGamePlayerList(params) {
    return request({
        url: '/bmmatch/GetBMMatchTennisGamePlayerList',
        method: 'get',
        params
    })
}

export function getBMGamePlayerList(params) {
    return request({
        url: '/bmmatch/GetBMGamePlayerList',
        method: 'get',
        params
    })
}

export function updateBMMatchTennisGameStatic(data) {
    return request({
        url: '/bmmatch/UpdateBMMatchTennisGameStatic',
        method: 'post',
        data
    })
}

export function adminGetBMMatchRankList(params) {
    return request({
        url: '/bmmatch/AdminGetBMMatchRankList',
        method: 'get',
        params
    })
}

export function adminUpdateBMTeamFinalRank(data) {
    return request({
        url: '/bmmatch/AdminUpdateBMTeamFinalRank',
        method: 'post',
        data
    })
}

export function getBMMatchUnionListByUser(params) {
    return request({
        url: '/bmmatch/GetBMMatchUnionListByUser',
        method: 'get',
        params
    })
}

export function cancelBMMatchTeamPlayer(params) {
    return request({
        url: '/bmmatch/CancelBMMatchTeamPlayer',
        method: 'get',
        params
    })
}

/** 获取我的赛事球员报名可用优惠券列表 */
export function getMyMatchPlayerSignupCouponTicketList(params) {
    return request({
        url: '/bmmatch/GetMyMatchPlayerSignupCouponTicketList',
        method: 'get',
        params
    })
}

export function bangsaishiCreatePlayerSignupOrder(params) {
    return request({
        url: url + '/api/BangsaishiCreatePlayerSignupOrder.json',
        method: 'get',
        params: params
    })
}

// 获取预支付订单信息
export function getWechatPrepayInfo(params) {
    return request({
        url: url + '/api/GetWechatPrepayInfo.json',
        method: 'get',
        params
    })
}
export function bangsaishiCheckTeamSignupOrder(params) {
    return request({
        url: url + '/api/BangsaishiCheckTeamSignupOrder.json',
        method: 'get',
        params
    })
}

export function getOrderDetail(params) {
    return request({
        url: '/bmmatch/GetOrderDetail',
        method: 'get',
        params
    })
}

export function adminDeleteBMGameEvent(data) {
    return request({
        url: '/bmmatch/AdminDeleteBMGameEvent',
        method: 'post',
        data
    })
}

export function getUnionSlideList(params) {
    return request({
        url: '/bmmatch/GetUnionSlideList',
        method: 'get',
        params
    })
}

export function bangsaishiCreateTeamSignupOrder(params) {
    return request({
        url: url + '/api/BangsaishiCreateTeamSignupOrder.json',
        method: 'get',
        params: params
    })
}

export function getBMMatchTeamPlayerList(params) {
    return request({
        url: '/bmmatch/GetBMMatchTeamPlayerList',
        method: 'get',
        params
    })
}

export function checkBMMatchBeforeSubmit(params) {
    return request({
        url: '/bmmatch/CheckBMMatchBeforeSubmit',
        method: 'get',
        params
    })
}

export function adminGetBMMatchStageTeamList(params) {
    return request({
        url: '/bmmatch/AdminGetBMMatchStageTeamList',
        method: 'get',
        params
    })
}

export function sendSmsValidationCode(params) {
    return request({
        url: url + '/api/SendSmsValidationCode.json',
        method: 'get',
        params
    })
}

export function updateBanmaUserMobile(data) {
    return request({
        url: '/bmmatch/UpdateBanmaUserMobile',
        method: 'post',
        data
    })
}

export function submitBMMatchTeam(data) {
    return request({
        url: '/bmmatch/SubmitBMMatchTeam',
        method: 'post',
        data
    })
}

export function adminGetMatchStageList(params) {
    return request({
        url: '/bmmatch/AdminGetMatchStageList',
        method: 'get',
        params
    })
}

export function getUserInspectionSetting(params) {
    return request({
        url: '/bmmatch/GetUserInspectionSetting',
        method: 'get',
        params
    })
}

export function updateUserInspectionSetting(data) {
    return request({
        url: '/bmmatch/UpdateUserInspectionSetting',
        method: 'post',
        data
    })
}

export function createUserInspectionSetting(data) {
    return request({
        url: '/bmmatch/CreateUserInspectionSetting',
        method: 'post',
        data
    })
}

export function adminGetBMUnionMatchGameList2(params) {
    return request({
        url: '/bmmatch/AdminGetBMUnionMatchGameList2',
        method: 'get',
        params
    })
}

export function getUserInspectionResult(params) {
    return request({
        url: '/bmmatch/GetUserInspectionResult',
        method: 'get',
        params
    })
}

export function checkPlayerByScan(data) {
    return request({
        url: '/bmmatch/CheckPlayerByScan',
        method: 'post',
        data
    })
}
export function adminUpdateScoreboardGame(data) {
    return request({
        url: '/bmmatch/AdminUpdateScoreboardGame',
        method: 'post',
        data
    })
}

export function confirmInspectionResult(data) {
    return request({
        url: '/bmmatch/ConfirmInspectionResult',
        method: 'post',
        data
    })
}

export function getBMMatchOrderListByUser(params) {
    return request({
        url: '/bmmatch/GetBMMatchOrderListByUser',
        method: 'get',
        params
    })
}

export function getBMMatchBaseBallStats(params) {
    return request({
        url: '/bmmatch/GetBMMatchBaseBallStats',
        method: 'get',
        params
    })
}

export function getBMMatchTeamPlayerBaseBallStats(params) {
    return request({
        url: '/bmmatch/GetBMMatchTeamPlayerBaseBallStats',
        method: 'get',
        params
    })
}

export function getBMMatchPlayerBaseBallStats(params) {
    return request({
        url: '/bmmatch/GetBMMatchPlayerBaseBallStats',
        method: 'get',
        params
    })
}

export function getBMMLBBaseballStatsByUser(params) {
    return request({
        url: '/bmmatch/GetBMMLBBaseballStatsByUser',
        method: 'get',
        params
    })
}

export function getBMMLBMatchBaseballStatsByUser(params) {
    return request({
        url: '/bmmatch/GetBMMLBMatchBaseballStatsByUser',
        method: 'get',
        params
    })
}

export function getUnionMatchRefereeList(params) {
    return request({
        url: '/bmmatch/AdminGetUnionMatchRefereeList',
        method: 'get',
        params
    })
}

export function createUnionMatchReferee(params) {
    return request({
        url: '/bmmatch/AdminCreateUnionMatchReferee',
        method: 'get',
        params
    })
}

export function getTeamLeaderTransferCode(params) {
    return request({
        url: '/bmmatch/GetTeamLeaderTransferCode',
        method: 'get',
        params
    })
}

export function claimTeamTransfer(params) {
    return request({
        url: '/bmmatch/ClaimTeamTransfer',
        method: 'get',
        params
    })
}
export function getAccountTeamListByUser(params) {
    return request({
        url: '/bmmatch/GetAccountTeamListByUser',
        method: 'get',
        params
    })
}
export function adminGetScoreboardList(params) {
    return request({
        url: '/bmmatch/AdminGetScoreboardList',
        method: 'get',
        params
    })
}
export function adminCreateScoreboard(params) {
    return request({
        url: '/bmmatch/AdminCreateScoreboard',
        method: 'get',
        params
    })
}
export function adminGetScoreboardGames(params) {
    return request({
        url: '/bmmatch/AdminGetScoreboardGames',
        method: 'get',
        params
    })
}
export function adminGetScoreboardGame(params) {
    return request({
        url: '/bmmatch/AdminGetScoreboardGame',
        method: 'get',
        params
    })
}
export function adminAddScoreboardGames(params) {
    return request({
        url: '/bmmatch/AdminAddScoreboardGames',
        method: 'get',
        params
    })
}
export function adminRemoveScoreboardGames(params) {
    return request({
        url: '/bmmatch/AdminRemoveScoreboardGames',
        method: 'get',
        params
    })
}
export function getOrganizationGameList(params) {
    return request({
        url: '/bmmatch/GetOrganizationGameList',
        method: 'get',
        params
    })
}
export function getOrganizationLiveGameList(params) {
    return request({
        url: '/bmmatch/GetOrganizationLiveGameList',
        method: 'get',
        params
    })
}


export function getBMGameLivePlaybackInfo(params) {
    return request({
        baseURL: process.env.VUE_APP_LIVE_API,
        url: '/api/content/phone/GetBMGameLivePlaybackInfo.json',
        method: 'get',
        params
    })
}

export function likePost(params) {
    return request({
        baseURL: process.env.VUE_APP_LIVE_API,
        url: '/api/content/phone/LikePost.json',
        method: 'get',
        params
    })
}
